<template>
  <div>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left-title" class="">
        <h1 class="title is-3">
          <span class="">Statistiques vendeurs</span>
        </h1>
      </div>
      <div class="column is-narrow is-paddingless is-border-left" slot="right-content">
        <a class="page-header-btn tooltip is-square is-tooltip-left is-tooltip-primary"
           :data-tooltip="fullscreen ? 'Réduire' : 'Agrandir'" @click="toggleFullscreen">
          <span class="icon">
            <i class="far" :class="fullscreen ? 'fa-compress-wide' : 'fa-expand-wide'"></i>
          </span>
        </a>
      </div>
    </sticky>

    <!--<div class="column is-paddingless is-border-left" slot="left-xxx">
      <a class="page-header-btn is-small" style="cursor: not-allowed;">
        <span class="icon is-small">
          <i class="fal fa-file-excel"></i>
        </span>
        <span>Export</span>
      </a>
    </div>
    <div class="column is-paddingless is-border-left" slot="left-xxxx">
      <a @click="cleanSelection" class="page-header-btn is-small">
        <span class="icon is-small">
          <i class="fal fa-trash"></i>
        </span>
        <span>supprimer selection</span>
      </a>
    </div>-->
    <div class="page-content is-padding-top">
      <div
        class="columns is-sticky-in-mainColumn is-zindex-8 is-gapless has-bg-white is-margin-left is-margin-right is-border">
        <div class="column is-10 is-8-widescreen">
          <stats-menu></stats-menu>
        </div>
        <div class="column"></div>
      </div>

      <div class="is-padding-top is-padding-right is-padding-left" data-sticky-pos-top="headerStats">

        <div class="has-bg-white is-border ">
          <div class="columns is-gapless">
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="startDatePicker" :config="periodConfigDate"
                              v-model="rawStartDate"
                              @on-change="updateStartDate"
                              @on-close="resetPeriod"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-border-right">
              <div class="field is-padding-left is-padding-right has-bg-lighter">
                <p class="control has-icons-left has-icons-right">
                  <flat-pickr id="endDatePicker" :config="periodConfigDate"
                              v-model="rawEndDate"
                              @on-close="resetPeriod"
                              @on-change="updateEndDate"
                              class="input is-fullwidth is-borderless has-bg-lighter"
                              name="date">
                  </flat-pickr>
                  <span class="icon is-small is-left has-text-black">
                    <i class="fal fa-calendar-alt is-size-4"></i>
                  </span>
                  <span class="icon is-large is-right has-text-dark">
                    <i class="far fa-chevron-down is-size-7"></i>
                  </span>
                </p>
              </div>
            </div>
            <div class="column is-3 is-padding-left is-padding-right">
              <div class="select is-fullwidth">
                <select id="period" @change="setCustomPeriod" v-model="period" class="is-borderless">
                  <option :value="null">Périodes</option>
                  <option v-for="period in periods" :value="period">{{period.label}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="is-border-top is-radius-top-left-large is-radius-top-right-large is-margin-top"
             id="tableaux">
          <div
            class="columns is-vcentered is-gapless is-border-right is-border-left is-border-bottom is-radius-top-left-large is-radius-top-right-large has-bg-light">
            <div class="column">
              <div class="is-tab-like is-tab-like--btnactivetransparent is-marginless-bottom columns ">
                <a :class="{'is-active': currentTable === TABLE_MODES.SELLERS}"
                   @click="changeTable(TABLE_MODES.SELLERS)"
                   v-if="isAdmin || isManager"
                   class="button is-small has-text-draft is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">Vendeurs</a>
                <a :class="{'is-active': currentTable === TABLE_MODES.POLES}" @click="changeTable(TABLE_MODES.POLES)"
                   v-if="isAdmin"
                   class="button is-small has-text-draft is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">Pôles</a>
                <a :class="{'is-active': currentTable === TABLE_MODES.GROUPS}" @click="changeTable(TABLE_MODES.GROUPS)"
                   v-if="isAdmin"
                   class="button is-small has-text-draft is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">Groupes</a>
                <a :class="{'is-active': currentTable === TABLE_MODES.COMPANIES}"
                   @click="changeTable(TABLE_MODES.COMPANIES)" v-if="isAdmin"
                   class="button is-small has-text-draft is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">Sociétés</a>
                <a v-if="userSelections" :class="{'is-active': currentTable === TABLE_MODES.CUSTOM}"
                   @click="changeTable(TABLE_MODES.CUSTOM)"
                   class="button is-small has-text-draft is-light is-invertedd is-transform-none is-padding-left-small is-padding-right-small is-min-width-0">
                  Ma sélection</a>
              </div>
            </div>
            <!-- <div class="column is-narrow is-padding-small" v-if="currentTable === TABLE_MODES.CUSTOM">
              <a class="has-text-grey is-size-6 is-uppercase" disabled="true" style="cursor: not-allowed;">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
                <span>Créer nouveau tableau</span>
              </a>
            </div> -->
            <div class="column is-narrow is-padding-small" v-if="showUserSelections">
              <a class="has-text-grey is-size-6 is-uppercase" @click="openQuickView">
                <span class="icon is-small"><i class="fal fa-plus"></i></span>
                <span>Ajouter une Entrée</span>
              </a>
            </div>
          </div>
          <div
            class="stat-header stat-header--sticky is-border-right is-border-left has-bg-white"
            :style="stickyStyles"
          >
            <div class="columns is-gapless is-size-7-touch is-size-7-desktop is-size-6-widescreen">
              <div class="column is-2 is-th">
                <div class="column is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('name')">
                    <span>Entité</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'name'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'name' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
              </div>
              <div class="columns column is-6">
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('reservationsCount')">
                    <span class="truncate"><span><abbr title="Réservations">Réservations</abbr></span></span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'reservationsCount'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'reservationsCount' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('actesCount')">
                    <span>Actes</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'actesCount'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'actesCount' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('cancelCounts')">
                    <span class="truncate"><span><abbr title="Annulation(s)">Annulation(s)</abbr></span></span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'cancelCounts'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'cancelCounts' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('CA')">
                    <span>CA</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'CA'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'cancelCounts' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('avgCA')">
                    <span>Prix de vente Moy.</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'avgCA'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'cancelCounts' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
              </div>
              <div class="columns column is-4">
                <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('COM')">
                    <span>COM</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'COM'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'COM' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small">
                  <a @click="sort('avgCOM')">
                    <span>Com Moy.</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'avgCOM'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'avgCOM' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-left-small"
                     v-if="displayRemuneration">
                  <a @click="sort('avgRemuneration')">
                    <span>Rémunération Moy.</span>
                    <span class="icon is-pulled-right">
                      <i v-if="sortBy != 'avgRemuneration'" class="fas fa-sort"></i>
                      <i v-else-if="sortBy == 'avgRemuneration' && sortOrder == 'asc'" class="fas fa-sort-up"></i>
                      <i v-else class="fas fa-sort-down"></i>
                    </span>
                  </a>
                </div>
                <div class="column is-2">
                </div>
              </div>
            </div>
          </div>
          <spinner-round :is-loading="$apollo.loading" v-if="$apollo.loading"></spinner-round>
          <div v-else>
            <seller-entity-row v-for="(e) in orderedEntities" :entity="e" v-if="e.data"
                               :is-open="currentEntity && currentEntity.pk === e.pk"
                               class="has-bg-white is-border is-relative is-margin-bottom-small"
                               :key="e.pk" @remove="removeEntity" @open="selectEntity" @setColor="updateEntityColor"
                               :can-be-remove="currentTable === TABLE_MODES.CUSTOM">
            </seller-entity-row>
            <seller-entity-row v-if="orderedEntities.length > 0 && totalRow" :entity="totalRow"
                               :is-open="false"
                               :is-total="true"
                               :can-be-remove="false" class="is-dark-blue stat-ligne--synthese">
            </seller-entity-row>
          </div>
          <div class="lignes-stat is-size-5-widescreen is-size-6-desktop is-size-6-touch"
               v-if="currentTable === TABLE_MODES.CUSTOM">
            <div @click="openQuickView" class="add-origine is-border columns is-border-dashed is-radius-large bloc-add is-margin-top-small">
              <div class="column is-uppercase">Ajouter une entrée</div>
              <div class="column is-narrow">
                <span class="">
                  <i class="fal fa-plus-square"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { mapGetters, mapState } from 'vuex'
  import randomColor from 'randomcolor'
  import moment from 'moment'
  import { StatsMx, StatsPeriodMx, StatsStickyMx } from '@/mixins'
  import Datepicker from 'vuejs-datepicker'
  import { findIndex, sortBy, isNil, uniqBy } from 'lodash'
  import SellerEntityRow from './SellerEntityRow'
  import DatePickerTooltip from '../../utils/DatePickerTooltip'
  import StatsMenu from '../StatsMenu'

  const TABLE_MODES = Object.freeze({
    SELLERS: 'SELLERS',
    POLES: 'POLES',
    GROUPS: 'GROUPS',
    COMPANIES: 'COMPANIES',
    CUSTOM: 'CUSTOM'
  })

  const salesStatsQuery = gql`query getStats($token: String, $entities: [JSONString], $startDate: String, $endDate: String){
        sellersStats(token: $token, entities: $entities, startDate: $startDate, endDate:$endDate)
        {pk, name, sales{pk, sale_price, status, seller_share, remuneration}, previousSales{sale_price, status, seller_share, remuneration},
        sellers{pk, name, seller{first_name, last_name}, sales{sale_price, status, seller_share, remuneration}, previousSales{sale_price, status, seller_share, remuneration}}
  }}`

  export default {
    name: 'SellersStats',
    apollo: {
      sellers: {
        query: gql`query getSellers($token: String, $profils: [String], $page: Int){
        users(profils: $profils, token: $token, page: $page){pages, page, users{pk, first_name, last_name, email, profil_type}}
        }`,
        variables () {
          return {
            page: 1,
            profils: ['seller', 'manager', 'admin'],
            token: this.token
          }
        },
        result (res) {
          let data = res.data
          if (data.users.page < data.users.pages) {
            this.loadMoreSellers(data.users.page + 1)
          }
        },
        update (data) {
          return data.users.users
        },
        skip () {
          return isNil(this.token)
        }
      },
      groups: {
        query: gql`query getManagers($token: String, $profils: [String]){
        users(profils: $profils, token: $token){pages, page, users{pk, first_name, last_name, email}}
        }`,
        variables () {
          return {
            page: this.managerPagination.page,
            profils: ['manager'],
            token: this.token
          }
        },
        update (data) {
          return data.users.users
        },
        skip () {
          return isNil(this.token)
        }
      },
      companies: {
        query: gql`query getCompanies($token: String){
        companies(token: $token){pk, name}
        }`,
        variables () {
          return {
            token: this.token
          }
        },
        skip () {
          return isNil(this.token)
        }
      },
      poles: {
        query: gql`query getPoles($token: String){
        poles(token: $token){pk, name}
        }`,
        variables () {
          return {
            token: this.token
          }
        },
        skip () {
          return isNil(this.token)
        }
      },
      sellersStats: {
        query: salesStatsQuery,
        variables () {
          // let delta = endDate.diff(startDate, 'days')
          // let previousStartDate = startDate.clone().subtract(delta, 'days')
          // let previousEndDate = endDate.clone().subtract(delta, 'days')
          return {
            token: this.token,
            entities: this.sellers.map(x => {
              return JSON.stringify({ pk: x.pk, key: 'USER' })
            }),
            startDate: moment(this.rawStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            endDate: moment(this.rawEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        },
        skip () {
          return this.sellers.length === 0
        },
        update (data) {
          return data.sellersStats
        }
      },
      userSelectionsStats: {
        query: salesStatsQuery,
        variables () {
          return {
            token: this.token,
            entities: this.userSelectionsEntities.map(x => {
              return JSON.stringify({ pk: x.pk, key: x.key })
            }),
            startDate: moment(this.rawStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            endDate: moment(this.rawEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        },
        skip () {
          return this.userSelectionsEntities.length === 0 || this.showUserSelections === false
        },
        update (data) {
          return data.sellersStats
        }
      },
      groupsStats: {
        query: salesStatsQuery,
        variables () {
          return {
            token: this.token,
            entities: this.groups.map(x => {
              return JSON.stringify({ pk: x.pk, key: 'USER' })
            }),
            startDate: moment(this.rawStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            endDate: moment(this.rawEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        },
        skip () {
          return this.groups.length === 0 || this.currentTable !== this.TABLE_MODES.GROUPS
        },
        update (data) {
          return data.sellersStats
        }
      },
      companiesStats: {
        query: salesStatsQuery,
        variables () {
          return {
            token: this.token,
            entities: this.companies.map(x => {
              return JSON.stringify({ pk: x.pk, key: 'COMPANY' })
            }),
            startDate: moment(this.rawStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            endDate: moment(this.rawEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        },
        skip () {
          return this.companies.length === 0 || this.currentTable !== this.TABLE_MODES.COMPANIES
        },
        update (data) {
          return data.sellersStats
        }
      },
      polesStats: {
        query: salesStatsQuery,
        variables () {
          return {
            token: this.token,
            entities: this.poles.map(x => {
              return JSON.stringify({ pk: x.pk, key: 'POLE' })
            }),
            startDate: moment(this.rawStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY'),
            endDate: moment(this.rawEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
          }
        },
        skip () {
          return this.poles.length === 0 || this.currentTable !== this.TABLE_MODES.POLES
        },
        update (data) {
          return data.sellersStats
        }
      }
    },
    mixins: [StatsMx, StatsPeriodMx, StatsStickyMx],
    components: {
      Datepicker,
      SellerEntityRow,
      DatePickerTooltip,
      StatsMenu
    },
    props: {},
    data () {
      return {
        stat: null,
        TABLE_MODES: TABLE_MODES,
        currentTable: null,
        sortBy: 'CA',
        sortOrder: 'desc',
        datePickerTooltip: false,
        data: {},
        currentEntity: null,
        sellers: [],
        sellerPagination: {
          autofetch: false,
          pages: null,
          page: 1
        },
        managerPagination: {
          pages: null,
          page: 1
        },
        groups: [],
        poles: [],
        companies: [],
        custom: [],
        loading: false,
        token: null,
        polesStats: [],
        currentSelectionIndex: 0,
        companiesStats: [],
        userSelections: [],
        userSelectionsEntities: [],
        userSelectionsStats: [],
        sellersStats: null,
        fullscreen: false
      }
    },
    computed: {
      ...mapState(['currentUser', 'quickview']),
      ...mapGetters(['currentUserPk', 'displayRemuneration', 'isAdmin', 'isManager', 'isSeller']),
      tableModeLabel () {
        return this.currentTable.toLowerCase()
      },
      statsEnabled () {
        return JSON.parse(this.$configs.STATS_ENABLED) === 1
      },
      entities () {
        let entities = {}

        let datas = [
          [TABLE_MODES.SELLERS, this.sellers, this.sellersStats, { showSellers: true }],
          [TABLE_MODES.GROUPS, this.groups, this.groupsStats, { showSellers: true }],
          [TABLE_MODES.COMPANIES, this.companies, this.companiesStats, { showSellers: true }],
          [TABLE_MODES.POLES, this.poles, this.polesStats, { showSellers: true }],
          [TABLE_MODES.CUSTOM, this.userSelectionsEntities, this.userSelectionsStats, { showSellers: true }]
        ]

        for (let i = 0; i < datas.length; i++) {
          let entry = datas[i]
          let table = entry[0]
          let elements = entry[1]
          let stats = entry[2]
          let params = entry[3]

          let processEntities = []

          for (let i = 0; i < elements.length; i++) {
            let source = elements[i]
            let name

            if (source.__typename === 'User' || source.key === 'USER') {
              name = `${source.first_name} ${source.last_name}`
            } else {
              name = source.name
            }
            let entity = Object.assign({
              name: name,
              data: null,
              _sales: [],
              _color: randomColor({
                seed: source.pk
              })
            }, source)

            if (table === TABLE_MODES.CUSTOM) {
              let target = this.userSelections.find(x => {
                return x.pk === source.pk
              })
              if (isNil(target)) {
                continue
              }
              this.$set(entity, '_selection', target._selection)
            }

            if (stats) {
              let entityStats = stats.find(x => {
                return entity.pk === x.pk
              })

              if (isNil(entityStats) === false && 'sales' in entityStats) {
                let sales = entityStats.sales.slice()
                // let previousSales = entityStats.previousSales.slice()
                this.$set(entity, '_sales', sales)
                // this.$set(entity, '_previousSales', previousSales)
                this.$set(entity, 'data', this.computedSalesData(sales, entity.pk))
                // this.$set(entity, 'previousData', this.computedSalesData(previousSales, entity.pk))
              }

              if (isNil(entityStats) === false && 'sellers' in entityStats && params.showSellers) {
                let sellers = entityStats.sellers
                let newSellers = sellers.map(seller => {
                  let newSeller = Object.assign({}, seller)
                  let sales = seller.sales.slice()
                  newSeller.sales = this.computedSalesData(sales, seller.pk)
                  return newSeller
                })
                this.$set(entity.data, 'sellers', newSellers)
              }
            }
            processEntities.push(entity)
          }

          this.$set(entities, table, processEntities)
        }

        return entities
      },
      selectedEntity () {
        if (this.showUserSelections) {
          return this.currentSelection
        } else if (this.currentTable in this.entities) {
          return this.entities[this.currentTable]
        } else {
          return []
        }
      },
      orderedEntities () {
        let currentEntities = this.selectedEntity
        if (this.sortBy) {
          let entities = sortBy(currentEntities, (x) => {
            if (this.sortBy in x) {
              return x[this.sortBy]
            } else if ('data' in x && !isNil(x.data) && this.sortBy in x.data) {
              return x.data[this.sortBy]
            }
          })
          if (this.sortOrder === 'asc') {
            return entities
          } else {
            return entities.reverse()
          }
        } else {
          return currentEntities
        }
      },
      showUserSelections () {
        return this.currentTable === 'CUSTOM'
      },
      currentSelection () {
        return this.entities[this.currentTable].filter(x => x._selection === this.currentSelectionIndex)
      },
      userSelectionsPk () {
        return this.userSelections.map(x => x.pk)
      },
      totalRow () {
        let sales = this.selectedEntity.filter(x => {
          return isNil(x._sales) === false && x._sales.length > 0
        }).reduce((accum, x) => {
          return accum.concat(x._sales)
        }, [])

        sales = uniqBy(sales, 'pk')

        return {
          name: 'SYNTHÈSE',
          data: this.computedSalesData(sales)
          // previousData: this.computedSalesData(previousSales)
        }
      },
      disabledDates () {
        return {
          to: this.rawStartDate
        }
      },
      startDate () {
        return moment(this.rawStartDate)
      },
      startDateLabel () {
        return this.startDate.format('MMMM YYYY')
      },
      endDate () {
        return moment(this.rawEndDate)
      },
      endDateLabel () {
        return this.endDate.format('MMMM YYYY')
      }
    },
    watch: {
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'ENTITY_SELECTION') {
            this.addEntities(results.entities, 'custom')
          }
        }
      }
    },
    methods: {
      loadMoreSellers (page) {
        this.$apollo.queries.sellers.fetchMore({
          variables: {
            page: page
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            let users = [...previousResult.users.users]
            fetchMoreResult.users.users.forEach(user => {
              let exists = users.find(x => x.pk === user.pk)
              if (!exists) {
                users.push(user)
              }
            })
            return {
              users: {
                __typename: previousResult.users.__typename,
                users,
                page: fetchMoreResult.users.page,
                pages: fetchMoreResult.users.pages
              }
            }
          }
        })
      },
      changeTable (table) {
        this.currentTable = table
      },
      selectEntity (entity) {
        if (this.currentEntity && this.currentEntity.pk === entity.pk) {
          this.currentEntity = null
        } else {
          this.currentEntity = entity
        }
      },
      sort (sortBy) {
        if (this.sortBy !== sortBy) {
          this.sortOrder = 'asc'
        } else {
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
        }
        this.sortBy = sortBy
      },
      getCustomFromLocalStorage () {
        this.$set(this, 'custom', [])
        let entities = localStorage.getItem(this.localStorageKey)
        if (entities && entities.length) {
          entities = JSON.parse(entities)
          this.addEntities(entities, 'custom')
        }
      },
      async loadUserSelections () {
        let res = await this.$api.currentUserService.getOne()
        let data = res.data
        if ('app_preferences' in data && 'seller_stats_selections' in data.app_preferences) {
          this.userSelections = data.app_preferences.seller_stats_selections
        }
        if (this.userSelections.length) {
          this.loadUserSelectionsData()
        }
      },
      async saveUserSelections () {
        let data = Object.assign({}, this.currentUser.app_preferences)
        data['seller_stats_selections'] = this.userSelections
        await this.$api.userService.patch(this.currentUserPk, { app_preferences: data })
        this.loadUserSelectionsData()
      },
      async cleanSelection () {
        let data = Object.assign({}, this.currentUser.app_preferences)
        data['seller_stats_selections'] = []
        await this.$api.userService.patch(this.currentUserPk, { app_preferences: data })
      },
      async loadUserSelectionsData () {
        let entities = []
        let usersPk = this.userSelections.filter(x => x.key === 'USER').map(x => x.pk)
        if (usersPk.length > 0) {
          let userRes = await this.$api.userService.get({ pk: usersPk })
          let users = userRes.data.items.map(x => {
            let y = Object.assign({}, x)
            y.key = 'USER'
            return y
          })
          entities = entities.concat(users)
        }

        let companiesPk = this.userSelections.filter(x => x.key === 'COMPANY').map(x => x.pk)
        if (companiesPk.length > 0) {
          let companyRes = await this.$api.companyService.get({ pk: companiesPk })
          let companies = companyRes.data.items.map(x => {
            let y = Object.assign({}, x)
            y.key = 'COMPANY'
            return y
          })
          entities = entities.concat(companies)
        }

        let polesPk = this.userSelections.filter(x => x.key === 'POLE').map(x => x.pk)
        if (polesPk.length) {
          let poleRes = await this.$api.poleService.get({ pk: polesPk })
          let poles = poleRes.data.items.map(x => {
            let y = Object.assign({}, x)
            y.key = 'POLE'
            return y
          })
          entities = entities.concat(poles)
        }

        this.userSelectionsEntities = entities
      },
      addEntities (entities, table = null) {
        let selection = this.userSelections
        entities.forEach(entity => {
          selection.push({ pk: entity.pk, key: entity.key, _selection: this.currentSelectionIndex })
        })
        this.userSelections = Array.from(new Set(selection))
        this.saveUserSelections()
      },
      removeEntity (entity) {
        let index = findIndex(this.userSelections, x => {
          return x.pk === entity.pk
        })
        if (index >= 0) {
          this.userSelections.splice(index, 1)
        }
        this.saveUserSelections()
      },
      updateStartDate (dates) {
        let startDate = moment(dates[0])
        let endDate = moment(this.rawEndDate, 'YYYY-MM-DD')
        if (startDate.isAfter(endDate)) {
          this.rawEndDate = startDate.endOf('month').toDate()
        }
        this.reloadSalesData()
      },
      updateEndDate (_) {
        this.reloadSalesData()
      },
      createColor (seed) {
        return randomColor({
          seed
        })
      },
      reloadSalesData () {
        console.log('reloadSalesData')
      },
      loadSaleData (entity) {
        console.log('loadSaleData for entity > ', entity)
      },
      updateEntityData (entity, rawData) {
        console.log('updateEntityData')
      },
      openQuickView () {
        let params = {
          mode: 'append'
        }
        if (this.isSeller) {
          params.customAlgoliaKey = ['POLE']
        }
        this.$store.commit('setQuickview', { mode: 'ENTITY_SELECTION', params })
      },
      closeQuickView () {
        this.$store.commit('setQuickview', {})
      },
      openStartMonthPicker () {
        this.$refs.startDatePicker.showCalendar()
      },
      openEndMonthPicker () {
        this.$refs.endDatePicker.showCalendar()
      },
      updateEntityColor (entity, color) {
        this.$set(entity, '_color', color)
      },
      updateEntityName (entity) {
        this.$set(entity, 'name', `${entity.first_name} ${entity.last_name}`)
      },
      toggleFullscreen () {
        this.fullscreen = !this.fullscreen
        if (this.fullscreen) {
          document.querySelector('body').classList.add('has-contentmain-fullscreen')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen-leave')
          document.querySelector('.l-header').style.zIndex = '0'
          document.querySelector('.l-navigationmain').style.zIndex = '0'
        } else {
          document.querySelector('body').classList.add('has-contentmain-fullscreen-leave')
          document.querySelector('body').classList.remove('has-contentmain-fullscreen')
          document.querySelector('.l-header').style.zIndex = '36'
          document.querySelector('.l-navigationmain').style.zIndex = '37'
        }
      }
    },
    created () {
      this.initPeriods()
      this.loadUserSelections()
      this.token = localStorage.getItem('token')
      this.rawStartDate = moment().startOf('year').toDate()
      this.rawEndDate = moment().endOf('month').toDate()
      if (this.isAdmin || this.isManager) {
        this.currentTable = TABLE_MODES.SELLERS
      } else {
        this.currentTable = TABLE_MODES.CUSTOM
      }
    }
  }
</script>

<style>
  #startDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }

  #endDatePicker {
    display: none !important;
    height: 0 !important;
    width: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/statistics/seller/SellerStats.vue